<section [hidden]="!active">
    <ng-content></ng-content>
</section>
